const BASE_URL = 'https://shd.shenhudong.com/'
export default {
  getWxSignature: BASE_URL + '/api/v1/weixin/get_signature',
  getWebUrl: BASE_URL + '/api/v1/weixin/get_web_url',
  getModel: BASE_URL + '/api/modules/common/index',
  addBehavior: BASE_URL + '/api/modules/recommend/addBehavior',
  getBehavior: BASE_URL + '/api/modules/recommend/getBehavior',
  getposter: BASE_URL + '/api/modules/recommend/getposter',
  signUp: BASE_URL + '/api/modules/recommend/submit',
  statistics: BASE_URL + '/api/modules/common/statistic',
  saveAddress: BASE_URL + '/api/modules/recommend/save_address',
  browse: BASE_URL + '/api/modules/recommend/browse',
  initWechatInfo: BASE_URL + '/api/modules/recommend/init_wechat_info',
  sendSms: BASE_URL + '/api/modules/eleven/send_sms',
  getBehaviorDetail: BASE_URL + '/api/modules/recommend/getBehaviorDetail',
  getReward: BASE_URL + '/api/modules/recommend/getReward',
  awardList: BASE_URL + '/api/modules/recommend/awardList',
  initVipInfo: BASE_URL + '/api/modules/recommend/init_vip_info',
  getUserInfo: BASE_URL + '/api/modules/recommend/getUserInfo',
  receiveAward: BASE_URL + '/api/modules/recommend/receiveAward',
  getMyAward: BASE_URL + '/api/modules/recommend/getMyAward',
}